// extracted by mini-css-extract-plugin
module.exports = {"ArticleList":"ComponentBodyArticleList_ArticleList__3zj7C","Articles":"ComponentBodyArticleList_Articles__kvAZd","Feeds":"ComponentBodyArticleList_Feeds__KuvG_"};